/**
 * Basic WP Staging Modal implemented with help of Sweetalerts
 */
export default class WpstgModal {
  constructor(
      confirmAction,
      wpstgObject = wpstg,
  ) {
    this.confirmAction = confirmAction;
    this.wpstgObject = wpstgObject;
  }

  show(swalOptions, additionalParams = {}, callback = null) {
    wpstgSwal.fire(swalOptions).then((result) => {
      if (result.value && this.error !== null) {
        this.triggerConfirmAction(additionalParams, callback);
      }
    });
  }

  triggerConfirmAction(additionalParams = {}, callback = null) {
    fetch(this.wpstgObject.ajaxUrl, {
      method: 'POST',
      credentials: 'same-origin',
      body: new URLSearchParams(Object.assign({
        action: this.confirmAction,
        accessToken: this.wpstgObject.accessToken,
        nonce: this.wpstgObject.nonce,
      }, additionalParams)),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then((response) => {
      if (response.ok) {
        return response.json();
      }

      return Promise.reject(response);
    }).then((response) => {
      if (callback !== null) {
        callback(response);
      }
    }).catch((error) => {
      console.log(this.wpstgObject.i18n['somethingWentWrong'], error);
    });
  }
}
